import React, {
    PureComponent
} from 'react';
import AnimatedView from '../../../components/componentsGeneral/AnimatedView/AnimatedView';
import DasboardContainer from '../../../components/componentsVas/Dashboard/DasboardContainer';


class dashboardView extends PureComponent {
    constructor(props) {
        super(props);
        this.state = {

        };
    }




    render() {
        return (
            <AnimatedView>
                <DasboardContainer isMobile={this.props.isMobile} warehouseSelection={this.props.warehouseSelection} customerSelection={this.props.customerSelection}/>
            </AnimatedView>

        );
    }
}

export default dashboardView;
